// locale for signUpFlow

import safeLoadLocale from '@cdo/apps/util/safeLoadLocale';

let locale = safeLoadLocale('signup_locale');
export default locale;
